import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const radiusParserPasswordTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Sip Setting',
  key: 'radiusParserPasswordTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['usage', 'password', 'trclvl'],
          ['state', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      access: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      owner: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      group: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      module: {
        type: 'text',
        initial: 'DEFAULT',
        hide: 'true',
      },
      usage: {
        label: 'User',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 16,
            },
          ],
        },
      },
      password: {
        label: 'Password',
        type: 'password',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 48,
            },
            {
              type: 'regexp',
              regexp: [
                'letters',
                'digits',
                'spaces',
                '-_.~!@#$%^*+?',
              ],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      trclvl: {
        label: 'Trace Level',
        type: 'select',
        initial: '0',
        options: [
          {
            label: 'None',
            value: '0'
          },
          {
            label: '1',
            value: '1'
          },
          {
            label: '2',
            value: '2'
          },
          {
            label: '3',
            value: '3'
          },
          {
            label: '4',
            value: '4'
          }
        ]
      },
      state: {
        label: 'State',
        type: 'text',
        readOnly: true,
        disabled: true,
      },
    },
  },
};
